import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {

  assignmentSubmitRequest,
  assignmentSubmitSuccess,
  assignmentSubmitFailure,
} from '../reducers/assignmentRequest';
import { API_LINK } from '../../constants';
import {getUserProgramsFullRequest, selectUserContent, setApproved} from '../reducers/userProgramsFull'; 
import {assignmentRequest} from '../reducers/assignmentRequest';
import { contentItemRequest } from '../reducers/contentList';
import { modulesListRequest } from '../reducers/modulesList';


const API = `${API_LINK}`;

function* assignmentSumbitAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const { selectedContentId: contentId, selectedAssessmentId, selectedProgramId, selectedModuleId, selectedRolloutId, approved, assessmentContent, cost, reference } = state.userProgramsFullReducer;
  const { assignmentRequestType, submitInfo } = state.assignmentRequest;
  
  console.log('End Submitx', +assessmentContent.survey_id)
  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}api/submitSingleExam?survey_id=`+assessmentContent.survey_id+'&user_id='+userId+'&module_id='+assessmentContent.module_id+'&rollout_id='+assessmentContent.rollout_id,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      data: submitInfo,
    }),
  );
  
  return response;
}

function* assignmentSubmitSaga() {
  try {
    const state = yield select(fullState => fullState);
    const { assignmentRequestType, submitInfo } = state.assignmentRequest;
    const response = yield call(assignmentSumbitAxios);
    yield put(selectUserContent(submitInfo.contentId));
    yield put(contentItemRequest())
    yield put(assignmentSubmitSuccess(response.data));
    yield put(contentItemRequest())
  } catch (error) {
    console.log('CAD2', error)
    yield put(assignmentSubmitFailure(error));
  }
}

export function* watcherAssignmentSubmitSaga() {
  yield takeLatest(assignmentSubmitRequest().type, assignmentSubmitSaga);
}
